import axiosInstance from '../utils/axios';

const API_BASE = '/api/v1';

const pluginsService = {

    listar: async (params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/plugins`, { params });
        return response.data;
    },

    listarPorCliente: async (clienteId, params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/clientes/${clienteId}/plugins`, { params });
        return response.data;
    },

    obter: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/plugins/${id}`);
        return response.data;
    },

    instalar: async (clienteId, pluginId) => {
        const response = await axiosInstance.post(`${API_BASE}/clientes/${clienteId}/plugins/${pluginId}/instalar`);
        return response.data;
    },

    desinstalar: async (clienteId, pluginId) => {
        const response = await axiosInstance.post(`${API_BASE}/clientes/${clienteId}/plugins/${pluginId}/desinstalar`);
        return response.data;
    },

};

export default pluginsService;
